<template>
  <div id="bla">
    <el-row>
      <el-col :span="24"
        ><div class="grid-content bg-purple-dark">1</div></el-col
      >
    </el-row>
    <el-row>
      <el-col :span="12"><div class="grid-content bg-purple">2</div></el-col>
      <el-col :span="12"
        ><div class="grid-content bg-purple-light">3</div></el-col
      >
    </el-row>
  </div>
</template>
<script>
export default {
  name: "TestPage"
}
</script>
